import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SdsDialogConfig } from '@gsa-sam/components';
import { FormlyFieldConfig } from '@ngx-formly/core';

@Component({
  selector: 'sam-frontend-admin-notifications-filter',
  templateUrl: './notifications-filter.component.html',
  styleUrls: ['./notifications-filter.component.css'],
})
export class NotificationsFilterComponent implements OnInit {
  model: any = {};
  @Input() filter: any;
  @Input() fields: FormlyFieldConfig[];
  @Output() filterEvent = new EventEmitter<any>();
  responsiveDialogOptions: SdsDialogConfig = {
    ariaLabel: 'Search Filters',
  };

  constructor() {
    // Intentionally blank. Comment is here to satisfy SonarQube
  }
  ngOnInit(): void {
    // Intentionally blank. Comment is here to satisfy SonarQube
  }

  filterChange(): void {
    this.filter = this.model;
    this.filter['domains'] = this.getDomains(this.model);
    this.filter['feedTypeId'] = this.getTypes(this.model);
    this.filter['keyword'] = this.getKeywords(this.model);
    this.filterEvent.emit(this.filter);
  }

  getDomains(data: any): any[] {
    const domainId = [];
    if (data.domain && data.domain.domainCheckbox) {
      for (const [value, label] of Object.entries(data.domain.domainCheckbox)) {
        if (label) {
          domainId.push(value);
        }
      }
    }
    return domainId;
  }

  getTypes(data: any): string {
    const typeId = [];
    if (data.types && data.types.typesCheckbox) {
      for (const [value, label] of Object.entries(data.types.typesCheckbox)) {
        if (label) {
          typeId.push(value);
        }
      }
    }
    return typeId.join(',');
  }

  getKeywords(data: any): string {
    const searchedTerms = [];
    if (data.keywords && data.keywords.length) {
      data.keywords.forEach(e => {
        searchedTerms.push(e.text);
      })
    }
    return searchedTerms.join(',');
  }

}
